/**
 * Enum Loại hình đơn vị
 */
export default {
    Enact: 1,
    Arise: 2,
};
